  import {ResponseLineItemModel, ResponseCartSummaryModel} from './index';
  export class ResponseCartModel {
    lineItems: ResponseLineItemModel[];
    cartSummary: ResponseCartSummaryModel;
}
